import React from 'react';

import Blog from '../board/blog';
import Sidebar from '../board/sidebar';

const Visit = props => {
    return (
        <div className="container g-pt-30 g-pb-60">
            <div className="row">
                <Sidebar />
                <Blog />
            </div>
        </div>
    )
}

export default Visit;


// WEBPACK FOOTER //
// ./src/pages/front/activity/visit.js